<template>
  <div>
    <div class="view-container end-0 me-2 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <div class="body-title">Listado de Transacciones</div>
      </div>

      <div class="content-view">
        <paginate
          ref="paginator"
          name="elements"
          :list="invoices"
          :per="15"
          :async="true"
        >
          <div class="col-4 my-2">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar factura"
              v-model="productSearch"
              @keyup="searchInvoices()"
            />
          </div>
          <table class="table table-hover">
            <thead class="border-bottom">
              <th class="col">No. Factura</th>
              <th class="col">Fecha</th>
              <th class="col">Usuario</th>
              <th class="col">ITBIS</th>
              <th class="col">Descuento</th>
              <th class="col">Total</th>
              <th class="col">Estado</th>
            </thead>
            <tbody>
              <tr v-for="(invoice, i) in paginated('elements')" :key="i" @click="openModal(invoice)">
                <td class="ps-3">#0{{ invoice.id }}</td>
                <td>{{ dateTimeFormat(invoice.created_at) }}</td>
                <td>{{ invoice.user.name }}</td>
                <td>{{ invoice.taxes }}</td>
                <td>{{ invoice.discount }}</td>
                <td>{{ formatNumber(invoice.total) }}</td>
                <td>
                  <div class="form-check form-switch col-1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="invoice.status == 'ACTIVE'"
                      @click.stop.prevent="confirmCancellation(invoice)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </paginate>
        <div >
          <paginate-links
            for="elements"
            :limit="9"
            :hide-single-page="true"
            :show-step-links="true"
            :step-links="{
              next: '  ❯',
              prev: '❮  '
            }"
          >
          </paginate-links>
        </div>
      </div>

      <!-- Modals -->
      <!-- invoice Detail -->
      <div
        class="modal fade"
        id="invoiceDetail"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <h5 class="modal-title fw-bold" id="exampleModalLabel">Detalle de la factura</h5>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <table class="table table-bordered border-primary mt-3 position-relative">
                <thead>
                  <th class="col-4">Nombre</th>
                  <th class="col-1 text-center">Cantidad</th>
                  <th class="col-2 text-center">Precio</th>
                  <th class="col-2 text-center">Imp.</th>
                  <th class="col-2 text-center">Total</th>
                </thead>
                <tbody style="line-height: 33px">
                  <tr v-for="(product, i) in selectedInvoice.products" :key="i">
                    <td>{{ product.name }}</td>
                    <td class="pe-4 text-center">{{ product.pivot.quantity }}</td>
                    <td>
                      <div class="d-flex justify-content-between">
                        <span>RD$</span>
                        <span>{{ product.pivot.price }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-between">
                        <span>RD$</span>
                        <span>{{ product.pivot.taxes }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-between">
                        <span>RD$</span>
                        <span>{{ formatNumber(productTotal(product.pivot.price, product.pivot.quantity)) }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      invoices: [],
      selectedInvoice: [],
      paginate: ["elements"],
      productSearch: null,
    };
  },
  methods: {

    searchInvoices(){
      axios.get("/invoice/all-invoices", {
        params: {
          search : this.productSearch
        }
      }).then((response) => {
        this.invoices = response.data.invoices;
      });
    },


    productTotal(price, qty) {
      if (qty == "") {
        qty = 0;
      }
      return isNaN(qty) ? 0 : (price * qty).toFixed(2);
    },

    /* Comentar */
    cancelTransaction(invoice) {
      axios.put("/invoice/cancel-transaction", { id: invoice.id }).then((response) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: response.data.success,
        });
        this.searchInvoices();
      });
    },

    confirmCancellation(invoice) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons.fire({
          title: "¿Está seguro?",
          text: "¡No podrás revertir esto!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "¡Sí, bórralo!",
          cancelButtonText: "¡No, cancela!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.cancelTransaction(invoice);
          }
        });
    },

    openModal(invoice) {
      axios.get(`/invoice/${invoice.id}`).then((response) => {
        this.selectedInvoice = response.data;
        const myModal = new bootstrap.Modal(document.querySelector("#invoiceDetail"), {});
        myModal.show();
      });
    },
  },
  mounted() {
    this.searchInvoices();
  },
};
</script>

<style lang="scss" scoped>
  .content-view{
    max-height: 890px !important;
  }
  table.table {
    border-color: #f5f5f5 !important;
    thead > th {
      padding: 10px 15px !important;
    }
    tbody > tr > td {
      padding-left: 15px /* !important */;
    }
  }
</style>
